<template>
    <div class='news-wrapper'>
        <div class='left-list scroll' ref=parent>
            <List ref='newsList' :detail='model' v-model='selectArticle' @change='handleSelectChange' />
        </div>
        <div class='right-content scroll' ref='articlceWrap'>
            <Article ref='newsContent' />
        </div>
    </div>
</template>

<script>
import Article from '@/pages/components/article';
import List from '@/pages/components/common_list';
import * as actions from '@/common/js/api'
export default {
    name: 'tags',
    data() {
        return {
            selectArticle: {},
            title: '',

        }
    },
    props: {
        model: {
            default() {
                return {
                    type: 'tags',
                    tag: '标签资讯',
                    // stockCode: ''
                }
            },
            type: Object
        }
    },
    provide() {
        return {
            selectArticle: () => (this.selectArticle),
            pageDetail: { ...this.model }
        }
    },
    components: {
        Article,
        List
    },
    computed: {
        hasLeft() {
            return this.model.treeid
        }
    },
    watch: {
        title: {
            handler(val) {
                this.takeThingsBack(val);
            }
        }
    },
    created: function () {
        // 迁移至common_list
        let { treeid, code, objid } = this.model
        //if (!treeid || !code || !objid) {
        //    this.$nextTick(() => {
        //        this.$refs.newsList.selectFirst()
        //    })
        //} else {
        //    this.$client.getSeqByObjid(objid, code, treeid).then(res => {
        //        this.$refs.newsList.handleItemClick(res)
        //    })
        //}
        this.title = decodeURIComponent(this.model.tagname) + '资讯'
    },
    mounted: function () {
    },
    methods: {
        handleSelectChange(e) {
            this.selectArticle = e;
            this.$refs.newsContent.initData(e);
        },
        filterId(obj) {
            return obj.id || obj.seq;
        },
        // 向外部边框传递信息
        takeThingsBack(title, collectInfo = {}) {
            this.$dispatch('basic', 'LISTEN_CHILD', {
                method: 'freshBaseInfo',
                data: {
                    componentName: this.model.componentName,
                    collectInfo,
                    title
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../common/style/index.less';
.news-wrapper {
    .flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 10px 6px 10px 10px;
    .left-list {
        width: 245px;
        padding-right: 10px;
        overflow: hidden;
    }
    .right-content {
        overflow: hidden;
        flex: 1;
        margin-left: 30px;
        padding-right: 24px;
        height: calc(100% - 5px);
    }
}
</style>
